import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Input, Select } from "antd";
import { useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { ClusterNodeNote } from "../../models/Cluster";
import { Option } from "../../models/generics";

type Props = {
  note?: ClusterNodeNote;
  nodesOptions?: Option[];
  onSubmit?: (values: any) => void;
  onCancel?: () => void;
};

export default function NoteForm({ note, onSubmit, onCancel, nodesOptions }: Props) {
  const [form] = Form.useForm();

  useEffect(() => form.setFieldsValue(note), [form, note]);

  return (
    <Form form={form} layout="vertical" className="compact-form" onFinish={onSubmit}>
      <Modal.Body>
        <Form.Item
          name="name"
          label="Name"
          className="mb-4"
          rules={[{ required: true, message: "Name is required" }]}
        >
          <Input className="w-100" placeholder="Note Name" />
        </Form.Item>
        <Form.Item
          name="description"
          label="Content"
          className="mt-2"
          rules={[{ required: true, message: "Content is required" }]}
        >
          <Input.TextArea className="w-100" rows={4} placeholder="Note Content" />
        </Form.Item>
        {nodesOptions && (
          <Form.Item
            name="nodeId"
            label="Node"
            className="mt-2"
            rules={[{ required: true, message: "You must select a node to proceed" }]}
          >
            <Select placeholder="Select Node" options={nodesOptions} />
          </Form.Item>
        )}
      </Modal.Body>
      <Modal.Footer className="justify-content-between">
        <Button type="button" variant="light" size="sm" className="border" onClick={onCancel}>Close</Button>
        <Button type="submit" variant="success" size="sm">
          <FontAwesomeIcon icon={solid('save')} />
          <span className="ms-2">Save</span>
        </Button>
      </Modal.Footer>
    </Form>
  )
}